import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  CardBody,
  Center,
  Image,
  Flex,
  Text,
  Heading,
  VStack,
  Grid,
  GridItem,
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../../ColorModeSwitcher";
import { Nav } from "../../containers/Nav";
import { Footer } from "../../containers/Footer";
import { getAllCampaigns } from "../../actions/campaigns";
import CampaignCard from "../../components/campaignCard";
import AdminNav from "../../components/adminNav";
import { validateAdminAuth, truncateLongText } from "../../helpers";

function AdminCampaigns() {
  const navigate = useNavigate();
  const [userBrand, setUserBrand] = useState("");
  const [brandCampaigns, setBrandCampaigns] = useState([]);
  const [fetchingCampaigns, setFetchingCampaigns] = useState(false);

  const [noCampaigns, setNoCampaigns] = useState(false);
  const lightGray = useColorModeValue("gray.100", "gray.900");

  const userInfo = validateAdminAuth();
  if (userInfo?.organization) {
    navigate("/brandCampaigns");
  } else if (!userInfo) {
    navigate("/login");
  }

  useEffect(() => {
    setFetchingCampaigns(true);

    getAllCampaigns().then((campaigns) => {
      if (campaigns.length) {
        setNoCampaigns(true);
      }
      setBrandCampaigns(campaigns);
      setFetchingCampaigns(false);
    });
  }, []);

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      color="blackAlpha.700"
      pb="75px"
    >
      <Nav />

      <GridItem pl="2" area={"main"}>
        <Center>
          <VStack>
            <AdminNav />
            {!fetchingCampaigns && !brandCampaigns.length && (
              <Center>
                <Box>
                  <Text>There are no active campaigns left to evaluate.</Text>
                </Box>
              </Center>
            )}

            {!fetchingCampaigns && brandCampaigns.length !== 0 && (
              <Card maxWidth="1200px" mx="5" my="5" p="3" bg={lightGray}>
                <Flex m="2">
                  <Box width="100%">
                    <Heading fontSize="2xl">All Campaigns</Heading>
                  </Box>
                </Flex>
                <TableContainer>
                  <Table variant="striped">
                    <Thead>
                      <Tr>
                        <Th>Action</Th>
                        {/*<Th>_Id</Th>*/}
                        <Th>Cover</Th>
                        <Th>Production Company</Th>
                        <Th>Name</Th>
                        <Th>Description</Th>
                        <Th>Medium</Th>
                        <Th>Genre</Th>
                      </Tr>
                    </Thead>
                    <Tbody fontSize="sm">
                      {brandCampaigns.map((campaign) => {
                      console.log(campaign)
                        return (
                          <Tr>
                            <Td>
                              <Link to={`/admin/campaigns/${campaign.brand}/${campaign.name}`}>
                                <Text color="teal" as="u">
                                  EDIT
                                </Text>
                              </Link>
                            </Td>
                            <Td>
                              <Image
                                src={
                                  "https://hubitprototype.herokuapp.com" +
                                  campaign.cover
                                }
                                fallbackSrc="https://via.placeholder.com/350x200"
                                boxSize="35px"
                                alt={`${campaign.brand} campaign cover image`}
                                borderRadius="lg"
                                width="100%"
                                objectFit="cover"
                              />
                            </Td>
                            <Td>{campaign.brand}</Td>
                            <Td>{campaign.name}</Td>
                            <Td>
                              {truncateLongText(campaign.description, 15)}
                            </Td>
                            <Td>{campaign.medium}</Td>
                            <Td>{campaign.genre}</Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Card>
            )}
          </VStack>
        </Center>
      </GridItem>

      <Footer />
    </Grid>
  );
}

export default AdminCampaigns;
